var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "avue-logo" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.keyCollapse
          ? _c("span", { key: "0", staticClass: "avue-logo_subtitle" }, [
              _vm._v("\n      " + _vm._s(_vm.website.logo) + "\n    "),
            ])
          : _vm._e(),
      ]),
      _c(
        "transition-group",
        { attrs: { name: "fade" } },
        [
          !_vm.keyCollapse
            ? [
                _c("span", { key: "1", staticClass: "avue-logo_title" }, [
                  _vm._v(_vm._s(_vm.website.indexTitle) + " "),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }